<template>
  <v-menu
    offset-y
  >
    <template v-slot:activator="{ on }">
      <v-btn text v-on="on" height="48" data-el="profile-btn">
        <v-avatar size="24px" color="blue-grey" class="mr-2">
          <v-icon size="18">mdi-account-outline</v-icon>
        </v-avatar>
        {{ auth.user && auth.user.fullName }}
        <v-icon class="ml-1">mdi-chevron-down</v-icon>
      </v-btn>
    </template>

    <v-list>
      <v-list-item v-if="hasAnyPermission('USER_EDIT')" @click="pushToRoute('UserSettings')">
        <v-list-item-icon><v-icon>mdi-account-edit</v-icon></v-list-item-icon>
        <v-list-item-title>{{ trans('user.settings') }}</v-list-item-title>
      </v-list-item>
      <v-list-item @click="logout">
        <v-list-item-icon><v-icon>mdi-logout</v-icon></v-list-item-icon>
        <v-list-item-title>{{ trans('auth.logout') }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import {RouterUtils} from './utils/router-utils';
import {mapGetters} from 'vuex';
import {MainUtils} from './utils/main-utils';
import {LocaleUtils} from '@/utils/locale-utils';

export default {
  name: 'HeaderUserMenu',
  mixins: [
    LocaleUtils,
    RouterUtils,
    MainUtils
  ],
  data: () => ({

  }),

  computed: {
    ...mapGetters({
      auth: 'auth',
      isAuthenticated: 'isAuthenticated'
    })
  },

  methods: {
    logout () {
      this.showGlobalLoadingOverlay();
      this.$auth.logout()
      .finally(() => { this.hideGlobalLoadingOverlay() });
    }
  }
}
</script>
